<template>
  <div style="height: 100%">
    <material-card
      color="#325181"
      title="Your activity stats as a Buyer"
      offset="0"
      style="height: 100%"
    >
      <v-layout justify-center wrap v-if="stats != undefined">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex class="mt-0" xs12 sm6 style="text-align: center">
              <v-layout class="pa-2" justify-center wrap>
                <v-flex xs12>
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 25pt !important;
                    "
                    class="mb-0"
                  >
                    {{ formatMoney(stats.cC) }}
                  </p>
                  <p style="color: #325181; font-size: 15pt !important">
                    Upstream contributions <br />
                    you've contributed through what <br />
                    you've bought (excl gst)
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="mt-0" xs12 sm6 style="text-align: center">
              <v-layout class="pa-2" justify-center wrap>
                <v-flex xs12>
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 25pt !important;
                    "
                    class="mb-0"
                  >
                    {{ calculateHrs(stats.cC) }}
                  </p>
                  <p style="color: #325181; font-size: 15pt !important">
                    Equivalent hours of generated <br />
                    community work
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    v-on="on"
                    class="mb-0"
                  >
                    {{ stats.attemptedLeadsCount }}
                  </p>
                  <p v-on="on" style="color: #325181">
                    Attempted Opportunities
                  </p>
                </template>
                <span
                  >These are opportunities we presented that you have marked
                  either "Already Using" or "No Opportunity"</span
                >
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                    v-on="on"
                  >
                    {{ stats.leadsCount }}
                  </p>
                  <p v-on="on" style="color: #325181">Active Opportunities</p>
                </template>
                <span
                  >These are opportunitities that dont have a clear outcome yet.
                  Click the button to reveal the details</span
                >
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <p
                style="
                  color: #325181;
                  font-weight: bold;
                  font-size: 20pt !important;
                "
                class="mb-0"
              >
                {{
                  parseInt(this.stats.enquiryEnquiries) +
                  parseInt(this.stats.commsConfirmedEnquiries) +
                  parseInt(this.stats.salePendingEnquiries) +
                  parseInt(this.stats.saleConfirmedEnquiries)
                }}
              </p>
              <p style="color: #325181">Active Enquiries</p>
            </v-flex>
          </v-layout>
          <!--  -->
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    v-on="on"
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                  >
                    {{ stats.saleCompletedEnquiries }}
                  </p>
                  <p v-on="on" style="color: #325181">Purchases Completed</p>
                </template>
                <span
                  >These are your purchases that have been marked as completed.
                  This number also includes purchasing from repeat sales that
                  have an ongoing element</span
                >
              </v-tooltip>
            </v-flex>
          </v-layout>
          <!--  -->
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    v-on="on"
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                  >
                    {{ stats.saleFallenThroughEnquiries }}
                  </p>
                  <p v-on="on" style="color: #325181">Unconverted Purchases</p>
                </template>
                <span
                  >These are your enquiries or links clicks that have not
                  resulted in a purchase
                </span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-0 mb-0" xs6 lg4 xl2 style="text-align: center">
          <v-layout class="pa-2" justify-center wrap>
            <v-flex xs12>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <p
                    v-on="on"
                    style="
                      color: #325181;
                      font-weight: bold;
                      font-size: 20pt !important;
                    "
                    class="mb-0"
                  >
                    {{ stats.suppliersUsed }}
                  </p>
                  <p v-on="on" style="color: #325181">
                    UNZ Suppliers you've enquired with & links you've visited
                  </p>
                </template>
                <span>
                  The Upstream Suppliers you've made an Enquiry with or visited
                  their website
                </span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="$vuetify.breakpoint.smAndUp" xs12 lg6 class="pb-4 mb-4">
          <apexChart
            height="300px"
            :options="upstreamStatusChartOptions"
            :series="upstreamStatusSeries"
          ></apexChart>
        </v-flex>
        <v-flex xs12 lg6>
          <v-layout row wrap>
            <v-flex xs12 class="py-4">
              <p style="font-weight: bold">
                You have
                <span style="color: red">
                  {{ stats.leadsToBeReviewed }}
                </span>
                opportunities we've identified to be reviewed
              </p>
              <v-btn
                block
                color="#58595b"
                dark
                @click="
                  $store.dispatch('reviewOpportunityButtonClicked');
                  $router.push(`/entityLink/${stats.businessLinkKey}`);
                "
              >
                Review your opportunities here
              </v-btn>
            </v-flex>
            <v-flex xs12 class="py-4">
              <p style="font-weight: bold">
                Your Impact Buyer report certificate
              </p>
              <v-btn block color="#325181" dark @click="downloadCertificate">
                Download Certificate
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </material-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import apexChart from "@/components/wrappers/apexChart.vue";

export default {
  props: ["stats"],
  components: { apexChart },
  data: () => ({
    upstreamStatusSeries: [],
    upstreamStatusChartOptions: {
      chart: {
        type: "donut",
      },
      fill: {},
      colors: ["#325181", "#4cc7e8", "#68c6b3", "#58595b"],
      labels: [
        "Active Leads",
        "Active Enquiries",
        "Sales Completed",
        "Sales Fallen Through",
      ],
    },
  }),
  computed: {
    ...mapGetters({}),
  },
  watch: {
    stats: function () {
      this.updateGraphs();
    },
  },
  mounted() {
    this.updateGraphs();
  },
  methods: {
    updateGraphs() {
      if (this.stats != undefined) {
        this.upstreamStatusSeries = [
          parseInt(this.stats.leadsCount),
          parseInt(this.stats.enquiryEnquiries) +
            parseInt(this.stats.commsConfirmedEnquiries) +
            parseInt(this.stats.salePendingEnquiries) +
            parseInt(this.stats.saleConfirmedEnquiries),
          parseInt(this.stats.saleCompletedEnquiries),
          parseInt(this.stats.saleFallenThroughEnquiries),
        ];
      }
    },
    calculatePercent(amount, total) {
      if (amount == 0) {
        return 0;
      }
      return parseFloat((parseInt(amount) / parseInt(total)) * 100).toFixed(1);
    },
    formatMoney(amount) {
      let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
    calculateHrs(cC) {
      if (cC != "") {
        return this.calculateCommunityHrs(cC) + "hrs";
      } else {
        return "0hrs";
      }
    },
    downloadCertificate() {
      window.open(
        `https://upstreamnz.live.simplesoftware.nz/impactBusiness/pdf/${this.stats.impactBusiness_id}`,
        "_blank",
        "location=no"
      );
    },
  },
  filters: {
    moment: function (date) {
      return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
    },
  },
};
</script>

<style lang="css">
#statsModule h4.title.font-weight-light.mb-2 {
  font-weight: bold !important;
}
</style>